module.exports = __webpack_public_path__ + "static/media/react1Router.b599d19b.png";